// extracted by mini-css-extract-plugin
module.exports = {"premium":"PremiumFlag_premium__3-TKm"};